import * as React from "react";
import MenuItem from "@mui/material/MenuItem";
import { TextField } from "@mui/material";
import { useState, useEffect, useMemo } from "react";
import { selectedClassAtom } from "../../../../components/Atoms/atoms";
import { useAtomValue } from "jotai";
import { isBlockDisabledForClass } from "./blockAssignment";

export default function BlockIdSelect(props) {
	const {
		value,
		inBatch,
		selectedBulkClassIds,
		rows,
		blockIds,
		width,
		marginTop,
		marginBottom,
		onChange,
		disabled,
		error,
		helperText,
		placeholderOptionLabel,
		fontSize,
	} = props;
	const selectedClass = useAtomValue(selectedClassAtom);
	const [anySmallCourse, setAnySmallCourse] = useState(false);

	useEffect(() => {
		if (rows && selectedBulkClassIds) {
			const selectedCourses = rows.filter((row) => selectedBulkClassIds.includes(row.classid));
			const smallCourse = selectedCourses.some((course) => course.csize < 10);
			setAnySmallCourse(smallCourse);
		}
	}, [selectedBulkClassIds, rows]);

	const isNursing = rows?.some((row) => row.dept === 79);

	const isOptionDisabled = React.useCallback(
		(option) => {
			if (!blockIds || !blockIds[option]) return false;
			return isBlockDisabledForClass({
				blockOption: blockIds[option],
				selectedClass,
				inBatch,
				anySmallCourse,
				selectedBulkClassIds,
				rows,
			});
		},
		[blockIds, selectedClass, inBatch, anySmallCourse, selectedBulkClassIds, rows],
	);

	// build array of all options & of only the enabled ones
	const allOptions = useMemo(() => Object.keys(blockIds || {}), [blockIds]);
	const validOptions = useMemo(
		() => allOptions.filter((opt) => !isOptionDisabled(opt)),
		[allOptions, isOptionDisabled],
	);

	// check whether the current value is still valid
	const isValueValid =
		value === "" || value === "EXCL" || validOptions.includes(value) || isNursing;

	return (
		<div>
			<TextField
				select
				disabled={disabled}
				size="small"
				error={error || !isValueValid}
				helperText={helperText}
				value={value || ""}
				onChange={onChange}
				margin="none"
				variant={"outlined"}
				sx={{
					width: width ? width : 140,
					marginBottom: marginBottom ? marginBottom : "20px",
					marginTop: marginTop ? marginTop : "0px",
					fontSize: fontSize ? fontSize : "10pt",
					backgroundColor: "#fff",
					".MuiInputBase-input": { fontSize: fontSize ? fontSize : "10pt", letterSpacing: -1 },
				}}
				SelectProps={{
					value: value || "",
					displayEmpty: true,
					onChange: onChange,
				}}
			>
				{placeholderOptionLabel ? (
					<MenuItem value="">
						<em>{placeholderOptionLabel}</em>
					</MenuItem>
				) : null}
				{blockIds &&
					Object.keys(blockIds).map((option) => (
						<MenuItem
							key={option}
							value={option}
							disabled={isOptionDisabled(option)}
							sx={{ fontSize: fontSize ? fontSize : "10pt" }}
						>
							{option}
						</MenuItem>
					))}
			</TextField>
		</div>
	);
}
